(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  if (L.Edit == null) {
    L.Edit = {};
  }

  L.Edit.BetterPoly = (function(superClass) {
    extend(BetterPoly, superClass);

    function BetterPoly() {
      this._createMiddleMarker = bind(this._createMiddleMarker, this);
      return BetterPoly.__super__.constructor.apply(this, arguments);
    }

    BetterPoly.prototype.initialize = function(poly, options) {
      BetterPoly.__super__.initialize.call(this, poly, options);
      return L.Edit.BetterPoly.include(L.Mixin.Events);
    };

    BetterPoly.prototype._initMarkers = function() {
      var latlngs;
      if (!this._markerGroup) {
        this._markerGroup = new L.LayerGroup();
      }
      this._markers = [];
      latlngs = this._getLatLngs();
      this._buildLineMarkers(latlngs);
      return this._prevLength = this._markers.length;
    };

    BetterPoly.prototype._getLatLngs = function() {
      return this.options.latlngs;
    };

    BetterPoly.prototype._buildLineMarkers = function(latlngs) {
      var i, j, k, len, marker, markerLeft, markerRight, ref, results, v;
      for (i = j = 0, len = latlngs.length; j < len; i = ++j) {
        v = latlngs[i];
        marker = this._createMarker(v, i);
        marker.on('click', this._onMarkerClick, this);
        this._markers.push(marker);
      }
      results = [];
      for (i = k = 0, ref = latlngs.length - 1; 0 <= ref ? k <= ref : k >= ref; i = 0 <= ref ? ++k : --k) {
        markerRight = this._markers[i];
        if (i === 0) {
          markerLeft = this._markers[latlngs.length - 1];
        } else {
          markerLeft = this._markers[i - 1];
        }
        this._createMiddleMarker(markerLeft, markerRight);
        results.push(this._updatePrevNext(markerLeft, markerRight));
      }
      return results;
    };

    BetterPoly.prototype._removeMarker = function(marker) {
      var i, ref, ref1, ref2, ref3, ref4, ref5;
      if (!this._destroyed) {
        if ((ref = this._poly) != null) {
          if ((ref1 = ref._map) != null) {
            if (typeof ref1.fire === "function") {
              ref1.fire('draw:point-begin-remove');
            }
          }
        }
      }
      i = marker != null ? marker._index : void 0;
      if (marker != null) {
        if ((ref2 = this._markerGroup) != null) {
          if (typeof ref2.removeLayer === "function") {
            ref2.removeLayer(marker);
          }
        }
        if ((ref3 = this._markers) != null) {
          ref3.splice(i, 1);
        }
        if ((ref4 = this.options) != null) {
          ref4.latlngs.splice(i, 1);
        }
        if (typeof this._updateIndexes === "function") {
          this._updateIndexes(i, -1);
        }
        if ((ref5 = this._poly) != null) {
          if (typeof ref5.redraw === "function") {
            ref5.redraw();
          }
        }
      }
      return marker != null ? typeof marker.clearAllEventListeners === "function" ? marker.clearAllEventListeners() : void 0 : void 0;
    };

    BetterPoly.prototype.removeHooks = function() {
      this._destroyed = true;
      this.clearAllEventListeners();
      return BetterPoly.__super__.removeHooks.call(this);
    };

    BetterPoly.prototype._onMarkerDrag = function(e) {
      BetterPoly.__super__._onMarkerDrag.call(this, e);
      return this._poly._map.fire('draw:point-edited');
    };

    BetterPoly.prototype._fireEdit = function() {
      this._poly.edited = true;
      if (this._prevLength < this._markers.length) {
        this._prevLength = this._markers.length;
        this._poly._map.fire('draw:point-removed');
      } else {
        this._poly._map.fire('draw:point-finished-edit');
      }
      return this._poly.fire('edit');
    };

    BetterPoly.prototype._createMarker = function(latlng, index) {
      var marker;
      marker = BetterPoly.__super__._createMarker.call(this, latlng, index);
      marker.on('dragstart', (function(_this) {
        return function() {
          return _this._poly._map.fire('draw:point-begin-edit');
        };
      })(this));
      marker.on('dragend', (function(_this) {
        return function() {
          return _this._poly._map.fire('draw:point-drag-end');
        };
      })(this));
      return marker;
    };

    BetterPoly.prototype._createMiddleMarker = function(marker1, marker2) {
      var latlng, marker, onDragEnd, onDragStart, ref;
      if (((ref = this._poly) != null ? ref._map : void 0) == null) {
        return;
      }
      latlng = this._getMiddleLatLng(marker1, marker2);
      marker = this._createMarker(latlng);
      marker.setOpacity(0.6);
      marker1._middleRight = marker2._middleLeft = marker;
      onDragStart = function() {
        var i;
        i = marker2._index;
        marker._index = i;
        marker.on('click', this._onMarkerClick, this);
        latlng.lat = marker.getLatLng().lat;
        latlng.lng = marker.getLatLng().lng;
        this.options.latlngs.splice(i, 0, latlng);
        this._markers.splice(i, 0, marker);
        marker.setOpacity(1);
        this._updateIndexes(i, 1);
        marker2._index++;
        this._updatePrevNext(marker1, marker);
        return this._updatePrevNext(marker, marker2);
      };
      onDragEnd = function() {
        var e;
        marker.off('dragstart', onDragStart, this);
        marker.off('dragend', onDragEnd, this);
        try {
          this._createMiddleMarker(marker1, marker);
          return this._createMiddleMarker(marker, marker2);
        } catch (error) {
          e = error;
        }
      };
      marker.on('dragstart', onDragStart, this).on('dragend', onDragEnd, this);
      return this._markerGroup.addLayer(marker);
    };

    return BetterPoly;

  })(L.Edit.Poly);

}).call(this);
